// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-1UILc";
var _3 = "body-2AEXJ";
var _4 = "header-1kJlX";
var _5 = "footer-21maq";
var _6 = "date-3-UlI";
var _7 = "short-TQK3G";
var _8 = "timeEnRoute__text-n05q1";
var _9 = "mobileSelectedFare-1UIIl";
var _a = "price-3cIRa";
export { _1 as "__esModule", _2 as "wrapper", _3 as "body", _4 as "header", _5 as "footer", _6 as "date", _7 as "short", _8 as "timeEnRoute__text", _9 as "mobileSelectedFare", _a as "price" }
export default { "__esModule": _1, "wrapper": _2, "body": _3, "header": _4, "footer": _5, "date": _6, "short": _7, "timeEnRoute__text": _8, "mobileSelectedFare": _9, "price": _a }
